/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Transition } from './mixins/_transition.mixin';

export default ($) => css`
  .fade {
    ${new Transition($.transitionFade).include($)};

    &:not(.show) {
      opacity: 0;
    }
  }

  .collapse {
    &:not(.show) {
      display: none;
    }
  }

  .collapsing {
    position: relative;
    height: 0;
    overflow: hidden;
    ${new Transition($.transitionCollapse).include($)};
  }
`;